import { ApiResponse } from '../../../../constants/types';
import {
  StudentRecentActivityItem,
  TeacherRecentActivityItem,
} from '../../../../constants/types/lms/dashboard/type';
import instance from '../../../axios/utils.ts/instance';

interface RecentActivityListParams {
  classId: string;
  limit: number;
}

/**
 * LMS > 클래스 홈 : 최근 활동 목록 조회
 * @param classId
 * @returns
 */
export const getRecentActivityList = async (
  params: RecentActivityListParams,
) => {
  const { classId, ...rest } = params;

  const result = await instance.get<
    ApiResponse<{ items: TeacherRecentActivityItem[] }>
  >(`/v1/lms/${classId}/jebson/recent-activity`, { params: rest });

  return result.data.data;
};

interface TeacherStudentRecentActivityListParams {
  classId: string;
}

/**
 * LMS > 클래스 홈 : 최근 활동 목록 조회 (교사 / 학생 분리)
 * @param classId
 * @returns
 */
export const getTeacherStudentRecentActivityList = async (
  params: TeacherStudentRecentActivityListParams,
) => {
  const { classId } = params;

  const result = await instance.get<
    ApiResponse<{
      teacherActivities: TeacherRecentActivityItem[];
      studentActivities: StudentRecentActivityItem[];
    }>
  >(`/v1/lms/${classId}/jebson/recent-activity/split`);

  return result.data.data;
};
